import s from './ChooseSocialMediaBlock.module.css';
import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
    selectCurrentProject,
    selectSelectedSocialMedia,
} from '../../../../store/selectors/projectSelectors';
import { setSelectedSocialMedia } from '../../../../store/slices/projectSlice';

import DropDownMenu from '../../../../shared/ui/dropdown-menu/DropDownMenu';
import { socialMediaOptions } from '../../../../shared/constant/constant';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import { useAppDispatch } from '../../../../store/store';
import { toast } from 'react-toastify';
const ChooseSocialMediaBlock = () => {
    const dispatch = useAppDispatch();

    const selectedSocialMedia = useSelector(selectSelectedSocialMedia);
    const currentProject = useSelector(selectCurrentProject);
    const platform =
        useSelector(selectSelectedSocialMedia) || currentProject?.content_type || 'linkedin';

    useEffect(() => {
        dispatch(setSelectedSocialMedia(platform));
    }, []);

    const handleUpdateProject = async (value: string) => {
        await dispatch(updateProject({ ...currentProject, content_type: value })).unwrap();
        await handleGenerateScript();

        dispatch(setSelectedSocialMedia(value));
    };
    const handleGenerateScript = async () => {
        if (currentProject?.id) {
            try {
                const response = await dispatch(
                    generateContent({ projectId: currentProject.id, kind: 'text_only' }),
                ).unwrap();
                console.log('Script generated successfully:', response);
            } catch (error: any) {
                toast.error(error?.message || 'Failed to handle generate script');
                console.error('Failed to handle generate script:', error);
            }
        }
    };
    return (
        <div className={s.container}>
            <h3 className={s.title}>Preview post</h3>
            <p className={s.subtitle}>Please select the platform you want to preview </p>

            <DropDownMenu
                options={socialMediaOptions}
                selectedOption={selectedSocialMedia || ''}
                setSelectedOption={(option) => handleUpdateProject(option)}
            />
        </div>
    );
};

export default ChooseSocialMediaBlock;
